import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { thunk } from "redux-thunk";

import { dossiersReducer, formulairesReducer, uiReducer } from "./reducers";

const rootReducer = combineReducers({
  dossiers: dossiersReducer,
  formulaires: formulairesReducer,
  ui: uiReducer,
});

const composeEnhancers = composeWithDevTools({ trace: true });

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;